import { format, parse } from 'date-fns';

export type AccountingCsvInput = {
  // '20/12/2024',
  Date: string;
  'N° facture': string;
  Bénéficiaire: string;
  Prestations: string;
  Type: string;
  Sécurisation: string;
  Statut: string;
  // '3,15',
  'Patient montant dû': string;
  'Patient statut': string;
  // '3,15',
  'Patient payé': string;
  'Moyen de paiement patient': string;
  // '28,35',
  'Tiers payant AMO montant dû': string;
  'Tiers payant AMO statut': string;
  'Tiers payant AMO montant payé': string;
  'Tiers payant AMC montant dû': string;
  'Tiers payant AMC montant statut': string;
  'Tiers payant AMC montant payé': string;
  // '3,15'
  'Total montant dû': string;
  'Statut de la facture': string;
  // '3,15'
  'Total montant payé': string;
};

export const formatDoctolibCsvDate = ({
  data,
}: {
  data: string | undefined;
}):
  | {
      error: 'empty_value' | Error;
      date: null;
    }
  | {
      error: null;
      date: string;
    } => {
  if (typeof data === 'undefined' || data === '' || data === '\n') {
    return {
      error: 'empty_value',
      date: null,
    };
  }

  let date: string;
  try {
    date = format(parse(data, 'dd/MM/yyyy', new Date()), 'yyyy-MM-dd');
  } catch (error: any) {
    return {
      date: null,
      error,
    };
  }

  return { date, error: null };
};

export const readDoctolibCsvRow = (row: AccountingCsvInput) => {
  // Parse date
  const { date, error } = formatDoctolibCsvDate({
    data: row.Date,
  });
  if (error) {
    if (error === 'empty_value') {
      return;
    }

    const message = error instanceof Error ? error.message : error;
    throw new Error(
      `validateCsvFile > Invalid transform csv data: Date ${message} - invoiceId=${row['N° facture']}`,
    );
  }

  return {
    date,
  };
};
